import React, { useState, useEffect, useContext } from "react";
import AdminContext from "../../context/adminContext/adminContext";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";
import PrintIcon from "@material-ui/icons/Print";
import {
	Modal,
	Backdrop,
	Fade,
	Button,
	Typography,
	Box,
	Table,
	TableRow,
	TableCell,
	TableHead,
	TableBody,
	IconButton,
} from "@material-ui/core";

//ESTILOS
const useStyles = makeStyles((theme) => ({
	modal: {
		display: "flex",
		alignItems: "center",
		justifyContent: "center",

		"@media print": {
			position: "absolute",
			top: "0px",
			left: "auto",
			maxHeight: "100%",
		},
	},
	paper: {
		backgroundColor: theme.palette.background.paper,
		border: "2px solid #000",
		boxShadow: theme.shadows[5],
		padding: theme.spacing(2, 4, 3),
		width: "310px",
		textTransform: "capitalize",
		maxHeight: "80%",
		overflow: "auto",
		"@media print": {
			position: "absolute",
			top: "0px",
			left: "auto",
			maxHeight: "100%",
		},
	},
	total: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
		margin: "1rem",
	},
	total1: {
		display: "flex",
		justifyContent: "flex-end",
		alignItems: "center",
	},
	table: {
		maxHeight: "600px",
	},
}));

const ModalTicket = (props) => {
	const {
		mesa,
		setisloading,
		openTicket,
		setopenTicket,
		setopenModal,
		setmesa,
	} = props;
	const adminContext = useContext(AdminContext);
	const classes = useStyles();
	const { closeMesa, finalizarPedido, actualizarPago } = adminContext;
	const [platos, setplatos] = useState([]);
	const [bebidaS, setbebidas] = useState([]);
	useEffect(() => {
		let platos = [];
		let bebidas = [];

		if (mesa) {
			//SEPARAR PLATOS Y BEBIDAS
			mesa.menu.forEach((men) => {
				if (men.platos && men.ingredientes.length > 0) {
					let menu = {
						items: null,
						precio: men.platos.precio,
					};
					if (men.platos.categoria === "hamburguesa") {
						menu.items = "Hamburguesa";
					} else {
						menu.items = "Milanesa";
					}
					men.ingredientes.forEach((ing) => {
						menu.items += ` *${ing.nombre}`;
						if (men.platos.categoria === "hamburguesa") {
							menu.precio = menu.precio + ing.precio_hamburguesa;
						} else {
							menu.precio = menu.precio + ing.precio_milanesa;
						}
					});
					platos.push(menu);
				}
				if (men.platos === null) {
					men.bebidas.forEach((beb) => {
						let menu = {
							items: null,
							precio: 0,
						};
						menu.items = beb.nombre;
						menu.precio = beb.precio;

						bebidas.push(menu);
					});
				}
				if (
					men.platos &&
					men.ingredientes.length === 0 &&
					men.bebidas.length === 0
				) {
					let menu = {
						items: men.platos.nombre,
						precio: men.platos.precio,
					};

					platos.push(menu);
				}
				if (men.platos && men.bebidas.length > 0) {
					let menu = {
						items: null,
						precio: men.platos.precio,
					};
					let beb = {
						item: null,
						precio: 0,
					};
					if (men.ingredientes.length > 0) {
						if (men.platos.categoria === "hamburguesa") {
							menu.items = "Hamburguesa";
							menu.ingredientes.forEach((ing) => {
								menu.items += ` *${ing.nombre}`;
								menu.precio += ing.precio_hamburguesa;
							});
						} else {
							menu.ingredientes.forEach((ing) => {
								menu.items += ` *${ing.nombre}`;
								menu.precio += ing.precio_milanesa;
							});
						}
					} else {
						menu.items = men.platos.nombre;
					}

					platos.push(menu);
					men.bebidas.forEach((bebi) => {
						beb.items = bebi.nombre;
						beb.precio += bebi.precio;
						bebidas.push(beb);
					});
				}
			});
			//BUSCAR BEBIDAS REPETIDAS
			let duplicados = [];

			bebidas.forEach((bebi) => {
				let item = {
					nombre: null,
					precio: 0,
					cantidad: 1,
				};

				var pos = bebi.items.indexOf(bebi.items);
				var idx = duplicados
					.map((i) => {
						return i.nombre;
					})
					.indexOf(bebi.items);

				if (pos > -1) {
					if (idx > -1) {
						duplicados[idx].cantidad++;
					} else {
						item.nombre = bebi.items;
						item.precio = bebi.precio;

						duplicados.push(item);
					}
				}
			});
			//BUSCAR MENU REPETIDOS
			let plato_duplicados = [];
			platos.forEach((plato) => {
				let item = {
					nombre: null,
					precio: 0,
					cantidad: 1,
				};
				var pos = plato.items.indexOf(plato.items);
				var idx = plato_duplicados
					.map((i) => {
						return i.nombre;
					})
					.indexOf(plato.items);

				if (pos > -1) {
					if (idx > -1) {
						plato_duplicados[idx].cantidad++;
					} else {
						item.nombre = plato.items;
						item.precio = plato.precio;

						plato_duplicados.push(item);
					}
				}
			});
			setplatos(plato_duplicados);
			setbebidas(duplicados);
		}
		// eslint-disable-next-line
	}, [mesa]);
	//FUNCIONES
	const handleClose = async (e) => {
		setopenTicket(false);
		if (mesa.tipo !== "Salon") {
			//ACTUALIZAR AL PRECIO VIEJO HACEEEEER
			if (mesa.forma_pago === "efectivo") {
				let precio = (mesa.precio_total * 100) / 90;
				let pago = null;
				await actualizarPago(mesa, precio, pago);
				setmesa({
					...mesa,
					precio_total: precio,
					forma_pago: pago,
				});
			} else {
				let pago = null;
				await actualizarPago(mesa, pago);
				setmesa({
					...mesa,
					forma_pago: pago,
				});
			}

			setopenModal(true);
		}
	};
	const cerrarMesa = async (mesa) => {
		setisloading(true);
		setopenTicket(false);
		await closeMesa(mesa);

		if (mesa.tipo !== "Salon") {
			await finalizarPedido(mesa);
		}
		setisloading(false);
	};
	return (
		<Modal
			aria-labelledby="transition-modal-title"
			aria-describedby="transition-modal-description"
			className={classes.modal}
			open={openTicket}
			closeAfterTransition
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<Fade in={openTicket}>
				<div className={classes.paper}>
					<Box m={2}>
						<Typography variant="h4" align="center">
							PILA
						</Typography>
						<Typography variant="h6" align="center">
							RESTOBAR PARRILLA
						</Typography>
					</Box>
					<Typography align="right">
						{moment().format("D/MM/YYYY HH:mm")}
					</Typography>
					<Box m={2}>
						<Typography variant="subtitle1" align="center">
							DETALLE ORDEN
						</Typography>
						<Typography variant="subtitle2" align="center">
							No valido como ticket
						</Typography>
						#######################
					</Box>
					<Box>
						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell colSpan={2}>Item </TableCell>
									<TableCell align="right" colSpan={2}>
										Precio{" "}
									</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{platos.length > 0
									? platos.map((plato) => {
											return (
												<TableRow key={Math.random()}>
													<TableCell colSpan={2}>
														{plato.nombre}
														{plato.cantidad === 0 || plato.cantidad === 1
															? null
															: ` X ${plato.cantidad}`}
													</TableCell>
													<TableCell align="right">
														${plato.precio * plato.cantidad}
													</TableCell>
												</TableRow>
											);
									  })
									: null}
								{bebidaS.length > 0
									? bebidaS.map((bebid) => {
											return (
												<TableRow key={Math.random()}>
													<TableCell colSpan={2}>
														{bebid.nombre}
														{bebid.cantidad === 0 || bebid.cantidad === 1
															? null
															: ` X ${bebid.cantidad}`}
													</TableCell>
													<TableCell align="right">
														${bebid.precio * bebid.cantidad}
													</TableCell>
												</TableRow>
											);
									  })
									: null}
							</TableBody>
						</Table>
					</Box>

					<div className={classes.total}>
						<Typography>TOTAL :</Typography>{" "}
						<Typography variant="h5">
							{" "}
							${mesa ? mesa.precio_total : null}
						</Typography>
					</div>
					---------------------------------------------------------
					
					<div className={classes.total1}>
						<Typography variant='subtitle2' >Propina sugerida 10%:{"  "} </Typography>
					    <Typography align="right" variant="h6"> {"  "}${mesa ? mesa.precio_total*0.10 : null}</Typography>
					</div>
					<div className={classes.total1}>
						<Typography variant='subtitle2' >Total con propina:</Typography> 
						<Typography align="right" variant="h6">${mesa ? (mesa.precio_total*0.10)+mesa.precio_total : null}</Typography>
					</div>				  	
					
							  	
					
						
					<Box displayPrint="none">
						<IconButton
							color="primary"
							aria-label="print"
							onClick={() => window.print()}
						>
							<PrintIcon />
						</IconButton>
						<Button fullWidth onClick={() => handleClose()}>
							Cancelar
						</Button>
						<Button
							fullWidth
							onClick={() => cerrarMesa(mesa)}
							variant="contained"
							color="primary"
						>
							Confirmar
						</Button>
					</Box>
				</div>
			</Fade>
		</Modal>
	);
};

export default ModalTicket;
